export type HistoryTab = {
  displayText: string;
  value: LeadHistorySection;
};

export enum LeadHistoryType {
  CALL = 'CALL',
  ACTION = 'ACTION',
  FILE = 'FILE',
  COMMENT = 'COMMENT'
}

export enum LeadActions {
  SendEmail = 'Send Email',
  SendSMS = 'Send SMS',
  CallBack = 'Call Back',
  None = 'None'
}

export enum LEAD_RATING {
  Rating1 = 'Rating1',
  Rating2 = 'Rating2',
  Rating3 = 'Rating3'
}

export enum LEAD_STATUS {
  New = 'New',
  Paused = 'Paused',
  Decline = 'Decline',
  Waiting = 'Waiting'
}

export enum LeadHistorySection {
  All = 'All',
  Responses = 'Responses',
  Conversations = 'Conversations',
  Files = 'Files',
  Meetings = 'Meetings',
  LeadStatus = 'Lead Status',
  LeadTransfer = 'Lead Transfer',
  Sale = 'Sale'
}

export enum LeadHistoryEventType {
  Response = 1,
  File = 2,
  Conversation = 3,
  Meeting = 4,
  StatusChange = 5,
  Transfer = 6,
  Sale = 7
}
